import PullRefresh from '../../../components/views/VanPullRefresh.js';
import Minxin from '../../../components/views/mixin.js';

var self, page, app;

export default {
    name: 'result',
    props: {
        msg: String
    },
    mixins: [Minxin, PullRefresh],
    data() {
        
        return {
            title: "",
            ruleForm: {
            },
            ui: {
                loading: false,
                loadingVerification: false,
            },             
        }
    },
    computed: {},
    created() {
        self = this;
        page = this.$route.meta.page;
        app = page.app;

        // page.loading();
    },
    mounted() {},
    activated() {},
    methods: {
        btnBack(){

        }
    }
}
